/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useContentZone } from "cms/components/hooks/use-content-zone";
import { ReuseComponentButton } from "cms/components/layout/reuse/find-component/reuse-component-button";
import { FindComponentDialog } from "cms/components/layout/reuse/find-component/dialog/find-component-dialog";
import { setLastComponentAdded } from "data/store/reducers/composer";

const ReuseComponent = (props) => {
    
    const { closeAddComponentModal, componentPosition, fieldName, isDisabled, size } = props;
    const { handleSelectComponentForReuse } = useContentZone();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    
    const closeWithDelay = async () => {
        setTimeout(async () => {
            handleCloseModal();
        }, 200);
    };

    const selectComponentAndCloseModal = async (operation, component, label) => {
        const newComponent = handleSelectComponentForReuse(fieldName, operation, component, label, componentPosition);
        dispatch(setLastComponentAdded(newComponent.guid));
        await closeWithDelay();
    };

    const reuseComponent = (component, label) => {
        selectComponentAndCloseModal("reuse", component, label);
    };

    const duplicateComponent = async (component, label) => {
        selectComponentAndCloseModal("duplicate", component, label);
    };

    const handleOpenModal = () => {
        setOpen(true);
    };

    const handleCloseModal = () => {
        if (closeAddComponentModal) {
            closeAddComponentModal();
        }
        setOpen(false);
    };

    return (
        <div>
            <ReuseComponentButton
                handleOpen={handleOpenModal}
                isDisabled={isDisabled}
                size={size}
            />
            <FindComponentDialog
                open={open}
                handleClose={handleCloseModal}
                reuseComponent={reuseComponent}
                duplicateComponent={duplicateComponent}
            />
        </div>
    );
};

export { ReuseComponent };
